<template>
  <v-container fluid fillheight>
    <v-row align="center" no-gutters>
      <v-col :md="nameMd" :lg="nameLg" :style="style" :class="classes">
        <div>
          {{name}}
          <v-icon v-if="info" class="icon" @click="showDialog = true">mdi-alert-circle-outline</v-icon>
          <span v-if="required" class="required">*</span>
          <v-icon v-if="secret" class="icon ml-2">mdi-lock</v-icon>
        </div>
        <div v-if="example" class="mt-2">
          <v-btn @click="showDialog = true" outlined>記入例</v-btn>
        </div>
        <v-dialog v-model="showDialog" max-width="600">
          <v-card>
            <v-card-title v-if="example">{{name}}の記入例</v-card-title>
            <v-card-title v-else />
            <v-card-text style="white-space:pre-wrap;">{{dialogMsg}}</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="showDialog = false" >閉じる</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
      <v-col :md="formMd" :lg="formLg"><slot/></v-col>
    </v-row>
  </v-container>
</template>

<script>
  import ComponentMixin from "../ComponentMixin";

  export default {
    mixins: [ComponentMixin],
    type: "molecule",
    name: "FormItem",
    props: {
      "name": String,
      "required": Boolean,
      "noMarginBottom": Boolean,
      "vertical": Boolean,
      "dialogMsg": String,
      "info": Boolean,
      "example": Boolean,
      "secret": Boolean,
      alignLabel: {
        type: String,
        default: '',
      }
    },
    data () {
      return {
        showDialog: false
      }
    },
    computed: {
      style () {
        return {
          marginBottom: this.noMarginBottom ? "none" : "30px"
        }
      },
      classes() {
        return {
          [`align-self-${this.alignLabel}`]: this.alignLabel
        }
      },
      nameMd () {
        return this.vertical ? 12 : 4;
      },
      nameLg () {
        return this.vertical ? 12 : 3;
      },
      formMd () {
        return this.vertical ? 12 : 8;
      },
      formLg () {
        return this.vertical ? 12 : 9;
      }
    }
  }
</script>

<style scoped lang="sass">
.required
  color: red
  margin-left: 8px

.icon
  display: inline-block
  padding-bottom: 6px
</style>
